<template>
  <div class="form-field">
    <md-card-content>
      <div class="md-layout-item md-small-size-100">
        <md-field class="number-parentId">
          <md-input type="hidden" v-model="value.organizationId" />
        </md-field>
        <md-autocomplete v-model="selectedOrgShortName"
          :md-options="organizations"
          :md-open-on-focus="false"
          md-input-id="org-auto-input"
          :class="messageClass('partyOrganizationId')"
          @md-changed="getOrganizations"
          @md-selected="onOrgSelect"
          ref="orgInput">
          <label v-lang.organization></label>
          <template slot="md-autocomplete-item" slot-scope="{ item, term }">
            <md-highlight-text :md-term="term.shortName">{{ item.shortName }}</md-highlight-text>
          </template>
          <span class="md-error">{{ errors.partyOrganizationId }}</span>
        </md-autocomplete>
        <md-field :class="messageClass('cardNumber')">
          <label for="member-cardNumber" class="required"><span v-lang.cardNumber></span></label>
          <md-input type="text" name="member-cardNumber" id="member-cardNumber" v-model="value.cardNumber"/>
          <span class="md-error">{{ errors.cardNumber }}</span>
        </md-field>
      </div>
      <div class="md-layout-item md-small-size-100">
        <md-field :class="messageClass('lastName')">
          <label for="member-lastName" class="required"><span v-lang.lastName></span></label>
          <md-input type="text" name="member-lastName" id="member-lastName" v-model="value.lastName"/>
          <span class="md-error">{{ errors.lastName }}</span>
        </md-field>
      </div>
      <div class="md-layout-item md-small-size-100">
        <md-field :class="messageClass('firstName')">
          <label for="member-firstName" class="required"><span v-lang.firstName></span></label>
          <md-input type="text" name="member-firstName" id="member-firstName" v-model="value.firstName"/>
          <span class="md-error">{{ errors.firstName }}</span>
        </md-field>
      </div>
      <div class="md-layout-item md-small-size-100">
        <md-field :class="messageClass('patronymic')">
          <label for="member-patronymic" class="required"><span v-lang.patronymic></span></label>
          <md-input type="text" name="member-patronymic" id="member-patronymic" v-model="value.patronymic"/>
          <span class="md-error">{{ errors.patronymic }}</span>
        </md-field>
      </div>
      <div class="md-layout-item md-small-size-100">
        <md-field :class="messageClass('mobilePhoneNumber')">
          <label for="member-mobilePhoneNumber" class="required"><span v-lang.mobilePhoneNumber></span></label>
          <md-input type="text" name="member-mobilePhoneNumber" id="member-mobilePhoneNumber" v-model="value.mobilePhoneNumber"/>
          <span class="md-error">{{ errors.mobilePhoneNumber }}</span>
        </md-field>
      </div>
    </md-card-content>
  </div>
</template>

<script>
import OrganizationService from '@/common/services/organization'
import parseBadRequest from '@/utils/parse-bad-request'
import testForErrorCode from '@/utils/test-for-err-code'
import ERRCODES from '@/utils/error-codes'

export default {
  name: 'MemberFormFields',
  props: {
    value: {
      type: Object
    },
    errorMessage: {
      type: String
    },
    selectOrg: {
      type: Object,
      default: null
    }
  },
  data () {
    return {
      /** @type {Organization[]} */
      organizations: [],
      selectedOrgShortName: null
    }
  },
  watch: {
    selectOrg (val) {
      if (val !== null) {
        this.selectedOrgShortName = val.shortName
      }
    }
  },
  computed: {
    errors () {
      return this.parseErrorMessage()
    }
  },
  mounted () {
    this.$el.querySelector('#org-auto-input').addEventListener('blur', this.hideOrgOptions)
  },
  destroyed () {
    this.$el.querySelector('#org-auto-input').removeEventListener('blur', this.hideOrgOptions)
  },
  methods: {
    messageClass (field) {
      return {
        'md-invalid': this.errors[field]
      }
    },
    parseErrorMessage () {
      const errors = {}

      const errorMessages = parseBadRequest(this.errorMessage)
      if (errorMessages.length > 0) {
        errorMessages.forEach(errorMsg => {
          if (testForErrorCode(ERRCODES.members.cardNumberMaxLen, errorMsg)) {
            errors.cardNumber = this.translate('error_2_11')
          } else if (testForErrorCode(ERRCODES.members.isBusyCardName, errorMsg)) {
            errors.cardNumber = this.translate('error_2_12')
          } else if (testForErrorCode(ERRCODES.members.lastNameMinLen, errorMsg)) {
            errors.lastName = this.translate('error_2_13')
          } else if (testForErrorCode(ERRCODES.members.lastNameMaxLen, errorMsg)) {
            errors.lastName = this.translate('error_2_14')
          } else if (testForErrorCode(ERRCODES.members.firstNameMinLen, errorMsg)) {
            errors.firstName = this.translate('error_2_15')
          } else if (testForErrorCode(ERRCODES.members.firstNameMaxLen, errorMsg)) {
            errors.firstName = this.translate('error_2_16')
          } else if (testForErrorCode(ERRCODES.members.patronymicMinLen, errorMsg)) {
            errors.patronymic = this.translate('error_2_17')
          } else if (testForErrorCode(ERRCODES.members.patronymicMaxLen, errorMsg)) {
            errors.patronymic = this.translate('error_2_18')
          } else if (testForErrorCode(ERRCODES.members.mobilePhoneNumber, errorMsg)) {
            errors.mobilePhoneNumber = this.translate('error_2_19')
          } else if (testForErrorCode(ERRCODES.members.isBusyTelefon, errorMsg)) {
            errors.mobilePhoneNumber = this.translate('error_2_20')
          } else if (errorMsg.indexOf('partyOrganizationId') !== -1) {
            errors.partyOrganizationId = this.translate('partyOrganizationId')
          } else if (errorMsg.indexOf('party organization id') !== -1) {
            errors.partyOrganizationId = errorMsg
          }
        })
      }

      return errors
    },
    getOrganizations (searchTerm) {
      if (searchTerm.length > 2) {
        OrganizationService.Select(0, searchTerm)
          .then(response => {
            const organizations = response.data.map(org => {
              // DIRTY HACK
              org.toLowerCase = () => org.shortName.toLowerCase()
              org.toString = () => org.shortName

              return org
            })
            this.organizations = organizations
          })
      } else if (typeof searchTerm === 'string') {
        this.organizations = []
        this.$emit('resetOrg')
      }
    },
    onOrgSelect (org) {
      this.$emit('orgSelected', org)
    },
    hideOrgOptions () {
      this.$refs.orgInput.showMenu = false
    }
  }
}
</script>

<style lang="scss" scoped>
.number-parentId {
  display: none;
}
</style>



// WEBPACK FOOTER //
// src/components/members/FormFields.vue